exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modalCrearOC .ag-theme-material .estilo-grilla[data-v-5058b74b] {\n  height: 100% !important;\n  width: 100% !important;\n}\n", ""]);

// exports
